import {
  COOKIE_CATEGORIES,
  COOKIE_CONSENT_STORAGE_KEY,
  COOKIE_CONSENT_VERSION
} from '../constants/cookieConsent';

const DEFAULT_PREFERENCES = {
  [COOKIE_CATEGORIES.ESSENTIAL]: true,
  [COOKIE_CATEGORIES.ANALYTICS]: false,
  [COOKIE_CATEGORIES.MARKETING]: false
};

const isBrowser = () => typeof window !== 'undefined';

export const getDefaultConsentPreferences = () => ({ ...DEFAULT_PREFERENCES });

export const getStoredCookieConsent = () => {
  if (!isBrowser()) return null;

  const raw = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    if (parsed.version !== COOKIE_CONSENT_VERSION) return null;

    const storedPreferences = parsed.preferences || {};

    return {
      version: parsed.version,
      updatedAt: parsed.updatedAt || null,
      source: parsed.source || 'customize',
      preferences: {
        ...DEFAULT_PREFERENCES,
        [COOKIE_CATEGORIES.ESSENTIAL]: true,
        [COOKIE_CATEGORIES.ANALYTICS]: Boolean(storedPreferences[COOKIE_CATEGORIES.ANALYTICS]),
        [COOKIE_CATEGORIES.MARKETING]: Boolean(storedPreferences[COOKIE_CATEGORIES.MARKETING])
      }
    };
  } catch (error) {
    return null;
  }
};

export const saveCookieConsent = ({ preferences, source = 'customize' }) => {
  if (!isBrowser()) return;

  const normalizedPreferences = {
    ...DEFAULT_PREFERENCES,
    ...(preferences || {}),
    [COOKIE_CATEGORIES.ESSENTIAL]: true
  };

  const payload = {
    version: COOKIE_CONSENT_VERSION,
    source,
    updatedAt: new Date().toISOString(),
    preferences: {
      [COOKIE_CATEGORIES.ESSENTIAL]: true,
      [COOKIE_CATEGORIES.ANALYTICS]: Boolean(normalizedPreferences[COOKIE_CATEGORIES.ANALYTICS]),
      [COOKIE_CATEGORIES.MARKETING]: Boolean(normalizedPreferences[COOKIE_CATEGORIES.MARKETING])
    }
  };

  window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(payload));
};
